module.exports = __webpack_public_path__ + "static/media/logo.75c3aa9c.png";